export type CvPreviewKind = 'pdf' | 'office' | 'text' | 'generic';

export function getExtensionFromFileName(fileName: string | null | undefined): string | null {
  if (!fileName?.trim()) {
    return null;
  }

  const base = fileName.trim().split(/[/\\]/).pop() ?? '';
  const dot = base.lastIndexOf('.');
  if (dot <= 0 || dot === base.length - 1) {
    return null;
  }

  return base.slice(dot + 1).toLowerCase();
}

export function getCvPreviewKind(fileName: string | null | undefined): CvPreviewKind {
  const ext = getExtensionFromFileName(fileName);
  if (ext === 'pdf') {
    return 'pdf';
  }
  if (ext && ['txt', 'text', 'md', 'csv', 'log', 'json', 'xml', 'tsv'].includes(ext)) {
    return 'text';
  }
  if (ext && ['doc', 'docx', 'xls', 'xlsx', 'xlsm', 'ppt', 'pptx'].includes(ext)) {
    return 'office';
  }
  return 'generic';
}

export function officeEmbedUrl(fileUrl: string): string {
  return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`;
}
